import type { PropsWithChildren } from "react";
import { atom, useAtomValue } from "jotai";
import { useHydrateAtoms } from "jotai/utils";
import { useForm } from "react-hook-form";
import { useLens } from "@hookform/lenses";
import type { ArtworkForm } from "@design-lab/shared/types";

type TransfersArtworksFormContextValue = {
  form: ReturnType<typeof useForm<ArtworkForm>>;
  lens: ReturnType<typeof useLens<ArtworkForm>>;
};

const transfersArtworksFormAtom = atom<TransfersArtworksFormContextValue | null>(null);

function useTransfersArtworksFormCreator(): TransfersArtworksFormContextValue {
  const form = useForm<ArtworkForm>({
    defaultValues: {
      currentPlacement: "front",
      selectedFrontPlacement: "front",
      back: {
        artworkId: "",
        size: {
          height: 0,
          width: 0
        }
      },
      front: {
        artworkId: "",
        size: {
          height: 0,
          width: 0
        }
      },
      frontLeftChest: {
        artworkId: "",
        size: {
          height: 0,
          width: 0
        }
      },
      info: {
        front: {
          enhancementTier: "full_enhancements",
          removeBackground: true,
          jiffyDesignServices: false
        },
        back: {
          enhancementTier: "full_enhancements",
          removeBackground: true,
          jiffyDesignServices: false
        }
      }
    },
    mode: "onChange"
  });

  const lens = useLens(form);

  return {
    form,
    lens
  };
}

export function TransfersArtworksFormProvider({ children }: PropsWithChildren) {
  const value = useTransfersArtworksFormCreator();
  useHydrateAtoms([[transfersArtworksFormAtom, value]]);
  return children;
}

export function useTransfersArtworksForm() {
  const value = useAtomValue(transfersArtworksFormAtom);
  if (!value) {
    throw new Error("TransfersArtworksFormProvider is missing");
  }
  return value;
}
